<template>
  <div :id="id" class="grid content-between bg-vdv-grey p-sm xl:p-md">
    <div class="text-center">
      <AvatarIcon
        v-if="person.image?.desktop.url !== ''"
        :size="EAvatarSize.lg"
        :image="person.image?.desktop.url"
      />
      <AvatarIcon v-else :size="EAvatarSize.lg" />
      <div class="mt-md">
        <b>{{ salutation }}</b>
        <p>{{ props.person.jobPosition ?? '' }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EAvatarSize } from '@/@types/avatar-icon';
import AvatarIcon from '@/components/components/core/avatar-icon.vue';
import type { PersonData } from '~~/src/server/transformers/EntityTransformers/personTransformer';

const props = defineProps({
  person: {
    type: Object as PropType<PersonData>,
    required: true,
    default: () => {
      return {};
    },
  },
  id: {
    type: String,
    required: true,
  },
});

const salutation = props.person.title
  ? `${props.person.title} ${props.person.firstName} ${props.person.lastName}`
  : `${props.person.firstName} ${props.person.lastName}`;
</script>
